import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL = 'api/item-adesao/estornar'

class ItemAdesaoEstornoApiClient {
	async buscarHistorico(objBusca) {
		const { paginacao, idItemAdesao } = objBusca

		const url = new SearchUrlParamBuilder({
			urlPath: `${URL}/historico`,
			filters: { idItemAdesao },
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		return await axios.get(url)
	}
	async estornar(input) {
		return await axios.put(`${URL}`, input)
	}
}

export default new ItemAdesaoEstornoApiClient()
